import React, { useEffect } from 'react';
import { LocationOnOutlined, PhoneOutlined, CheckCircleOutline } from '@mui/icons-material';
import '../styles/common.css';
import '../styles/SeoPages.css';
import goldHeroObj from '../images/gold-jewellery-hero.png'; // Using placeholder for now, user can update

const SilverJewelleryPage = () => {
    useEffect(() => {
        document.title = "Silver Jewellery in Jodhpur | 925 Sterling Silver – MAB Jewels";
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
            metaDesc.setAttribute("content", "Buy premium 925 sterling silver jewellery in Jodhpur at MAB Jewels. Explore silver payals, coins, rings & utensils. Pure silver, honest prices.");
        }
    }, []);

    return (
        <div className="page-container seo-page">
            <div className="seo-content-wrapper">
                <h1>Silver Jewellery in Jodhpur – 925 Sterling Silver</h1>

                {/* Hero Image */}
                <div className="seo-hero-image-container">
                    <img
                        src={goldHeroObj}
                        alt="Silver jewellery in Jodhpur – MAB Jewels"
                        className="seo-hero-image"
                        style={{ width: '100%', borderRadius: '12px', marginBottom: '30px', boxShadow: '0 8px 20px rgba(0,0,0,0.1)', filter: 'grayscale(100%)' }}
                    />
                </div>

                <p className="seo-intro">
                    Discover the elegance of <strong>Silver Jewellery in Jodhpur</strong> at MAB Jewels.
                    From traditional Rajasthani silver payals to modern sterling silver accessories, we offer purity you can trust.
                </p>

                <h2>Why Choose MAB Jewels for Silver?</h2>
                <ul className="seo-check-list">
                    <li><CheckCircleOutline sx={{ color: '#C0C0C0', mr: 1, fontSize: '1.2rem' }} /> 925 Sterling Silver Availability</li>
                    <li><CheckCircleOutline sx={{ color: '#C0C0C0', mr: 1, fontSize: '1.2rem' }} /> Traditional heavy Payals & Kandoras</li>
                    <li><CheckCircleOutline sx={{ color: '#C0C0C0', mr: 1, fontSize: '1.2rem' }} /> Silver Coins & Utensils for Gifting</li>
                    <li><CheckCircleOutline sx={{ color: '#C0C0C0', mr: 1, fontSize: '1.2rem' }} /> Transparent pricing by weight</li>
                </ul>

                <h2>Our Silver Collection</h2>
                <p>
                    Perfect for every occasion, our collection includes:
                </p>
                <ul>
                    <li>Silver Payals (Anklets) & Bichiyas (Toe Rings)</li>
                    <li>Silver Coins (Lakshmi - Ganesh)</li>
                    <li>Silver Utensils (Dinner Sets, Puja Thalis)</li>
                    <li>Sterling Silver Rings & Earrings</li>
                </ul>

                <h2>Visit Our Silver Jewellery Store in Jodhpur</h2>
                <p>
                    Experience the shine of pure silver at MAB Jewels.
                    <strong>Contact us</strong> for the latest designs and prices.
                </p>

                {/* Local SEO Boost */}
                <div className="local-seo-box" style={{ borderColor: '#C0C0C0' }}>
                    <h3>Contact MAB Jewels</h3>
                    <div className="seo-contact-row">
                        <LocationOnOutlined sx={{ color: '#C0C0C0', mr: 1 }} />
                        <span>Rajasthan, India</span>
                    </div>
                    <div className="seo-contact-row">
                        <PhoneOutlined sx={{ color: '#C0C0C0', mr: 1 }} />
                        <span>+91 94148 17620</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SilverJewelleryPage;
